// extracted by mini-css-extract-plugin
module.exports = {"match":"_28pr7ehHbRgONT-j1WH6iu"};